export default __webpack_public_path__ + "static/media/logo.ed2688e7.png";